import React from 'react';
import PropTypes from 'prop-types';

import { IconArrow } from './IconArrow';
import { IconCheck } from './IconCheck';
import { IconClose } from './IconClose';
import { IconDownload } from './IconDownload';
import { IconFacebook } from './IconFacebook';
import { IconHamburger } from './IconHamburger';
import { IconHome } from './IconHome';
import { IconInfo } from './IconInfo';
import { IconInstagram } from './IconInstagram';
import { IconLinkedIn } from './IconLinkedIn';
import { IconLogin } from './IconLogin';
import { IconQuestion } from './IconQuestion';
import { IconSearch } from './IconSearch';
import { IconPlus } from './IconPlus';
import { IconMinus } from './IconMinus';
import { IconTwitter } from './IconTwitter';
import { IconUpload } from './IconUpload';
import { IconWifi } from './IconWifi';
import { IconYoutube } from './IconYoutube';
import { IconFallback } from './IconFallback';

//TODO: Add smaller IconCheck
const getIcon = (icon) => {
  switch (icon) {
    case 'arrow':
      return IconArrow;
    case 'hamburger':
      return IconHamburger;
    case 'download':
      return IconDownload;
    case 'upload':
      return IconUpload;
    case 'login':
      return IconLogin;
    case 'info':
      return IconInfo;
    case 'question':
      return IconQuestion;
    case 'close':
      return IconClose;
    case 'home':
      return IconHome;
    case 'check':
      return IconCheck;
    case 'wifi':
      return IconWifi;
    case 'facebook':
      return IconFacebook;
    case 'linkedin':
      return IconLinkedIn;
    case 'youtube':
      return IconYoutube;
    case 'instagram':
      return IconInstagram;
    case 'twitter':
      return IconTwitter;
    case 'plus':
      return IconPlus;
    case 'minus':
      return IconMinus;
    case 'search':
      return IconSearch;

    default:
      return IconFallback;
  }
};

const getSize = (size) => {
  switch (size) {
    case 'xs':
      return 3;
    case 'sm':
      return 4;
    case 'md':
      return 7;
    case 'lg':
      return 9;

    default:
      return 7;
  }
};

export const Icon = ({ icon, size, ...props }) => {
  const iconSize = getSize(size);

  const iconProps = {
    ...props,
    width: iconSize,
    height: iconSize,
    viewBox: '0 0 30 30',
  };

  const IconComponent = getIcon(icon);

  return <IconComponent {...iconProps} />;
};

Icon.propTypes = {
  icon: PropTypes.oneOf([
    'arrow',
    'hamburger',
    'download',
    'upload',
    'login',
    'info',
    'question',
    'close',
    'home',
    'check',
    'wifi',
    'facebook',
    'linkedin',
    'youtube',
    'instagram',
    'twitter',
    'plus',
    'minus',
    'search',
  ]),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
};
